/**
 * @generated SignedSource<<f0beb1d83aed797696c43c70804ba497>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastSpace_storecastSpace$data = {
  readonly height: number;
  readonly id: string;
  readonly subWidgets: ReadonlyArray<{
    readonly __typename: string;
    readonly height: number;
    readonly id: string;
    readonly positionX: number;
    readonly positionY: number;
    readonly " $fragmentSpreads": FragmentRefs<"InteractiveWidgetWrapper_widget" | "StorecastSpaceWidget_subWidget">;
  }>;
  readonly " $fragmentType": "StorecastSpace_storecastSpace";
};
export type StorecastSpace_storecastSpace$key = {
  readonly " $data"?: StorecastSpace_storecastSpace$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastSpace_storecastSpace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastSpace_storecastSpace",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "subWidgets",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "positionX",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "positionY",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InteractiveWidgetWrapper_widget"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StorecastSpaceWidget_subWidget"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StorecastSpace",
  "abstractKey": null
};
})();

(node as any).hash = "2b7e718dc55c33062b97674e63a20a5f";

export default node;
